module.exports = __webpack_public_path__ + "img/ocu.dd602db5.png";